<template>
    <div class="GraphDemo">
        <RPStatCardRow class="GraphDemo__row">
            <RPStatCard status="success" />
            <RPStatCard status="success" />
            <RPStatCard status="success" />
            <RPComparisonCard status="success" />
        </RPStatCardRow>
        <div class="GraphDemo__row">
            <RPDonutCard
                class="GraphDemo__single-chart"
                header="Donut Card"
                header-tooltip="Tooltip"
                :chart-data="cardOneData"
            />
            <RPDonutCard
                class="GraphDemo__single-chart"
                header="Donut Card"
                header-tooltip="Tooltip"
                :chart-data="cardOneData"
                legend-position="left"
            />
            <RPMultiDonutCard
                class="GraphDemo__multi-chart"
                header="Multi Donut Card"
                header-tooltip="Tooltip"
                :chart-data="cardTwoData"
            />
        </div>
        <div class="GraphDemo__row">
            <RPTableGraphCard
                class="GraphDemo__table-chart"
                header="Table Card"
                header-tooltip="Tooltip"
                name-header="Name"
                data-header="Data"
                :table-data="tableData"
            />
        </div>
        <div class="GraphDemo__row--bar">
            <RPBarChartCard
                class="GraphDemo__bar-chart"
                header="Bar Card"
                header-tooltip="Tooltip"
                :chart-data="barChart"
            />
            <RPBarChartCard
                class="GraphDemo__bar-chart"
                header="Bar Card"
                header-tooltip="Tooltip"
                :chart-data="barOneChart"
                x-axis-label="xAxisLabel"
            />
        </div>
        <div class="GraphDemo__row">
            <RPBulletGraphCard
                class="GraphDemo__bar-chart"
                header="Thin Bullet Card"
                header-tooltip="Tooltip"
                :chart-data="bulletOne"
            />
            <RPBulletGraphCard
                class="GraphDemo__bar-chart"
                header="Thin Bullet Card"
                header-tooltip="Tooltip"
                :chart-data="bulletOne"
                type="thick"
            />
        </div>
        <div class="GraphDemo__row">
            <RPMultiLineGraphCard
                class="GraphDemo__line-chart"
                header="Multi Line Graph"
                :graph-data="multiLineData"
            />
            <RPSingleLineGraphCard
                class="GraphDemo__line-chart"
                header="Single Line Graph"
                :graph-data="singleLineData"
            >
                <template v-slot:cards>
                    <RPHeaderCard
                        header="Title"
                        number="750"
                        highlighted
                    />
                    <RPHeaderCard
                        header="Title"
                        number="750"
                    />
                </template>
            </RPSingleLineGraphCard>
        </div>
    </div>
</template>
<script>
import RPStatCard from 'components/Complex/Graphs/StatCard/RPStatCard.vue';
import RPComparisonCard from 'components/Complex/Graphs/StatCard/RPComparisonCard.vue';
import RPStatCardRow from 'components/Complex/Graphs/StatCard/RPStatCardRow.vue';
import RPDonutCard from 'components/Complex/Graphs/DonutChart/RPDonutCard.vue';
import RPMultiDonutCard from 'components/Complex/Graphs/DonutChart/RPMultiDonutCard.vue';
import RPTableGraphCard from 'components/Complex/Graphs/TableGraph/RPTableGraphCard.vue';
import RPBarChartCard from 'components/Complex/Graphs/BarChart/RPBarChartCard.vue';
import RPMultiLineGraphCard from 'components/Complex/Graphs/LineGraph/RPMultiLineGraphCard.vue';
import RPSingleLineGraphCard from 'components/Complex/Graphs/LineGraph/RPSingleLineGraphCard.vue';
import RPHeaderCard from 'components/Complex/Graphs/LineGraph/RPSingleLineGraph/RPHeaderCard.vue';
import RPBulletGraphCard from 'components/Complex/Graphs/BulletGraphs/RPBulletGraphCard.vue';
import colors from 'style/_colors.scss';

export default {
    name: 'GraphDemo',
    components: {
        RPStatCard,
        RPComparisonCard,
        RPStatCardRow,
        RPDonutCard,
        RPMultiDonutCard,
        RPTableGraphCard,
        RPBarChartCard,
        RPMultiLineGraphCard,
        RPSingleLineGraphCard,
        RPHeaderCard,
        RPBulletGraphCard
    },
    data(){
        return {
            cardOneData: [
                {
                    key: "positive_reviews",
                    label: "Positive",
                    color: '#A0E199',
                    count: 7
                },
                {
                    key: "neutral_reviews",
                    label: "Neutral",
                    color: '#FCE494',
                    count: 0
                },
                {
                    key: "negative_reviews",
                    label: "Negative",
                    color: '#FE4027',
                    count: 4,
                }
            ],
            cardTwoData: [
                [
                    {
                        key: "positive_reviews",
                        label: "Positive",
                        color: '#A0E199',
                        count: 7
                    },
                    {
                        key: "neutral_reviews",
                        label: "Neutral",
                        color: '#FCE494',
                        count: 0
                    },
                    {
                        key: "negative_reviews",
                        label: "Negative",
                        color: '#FE4027',
                        count: 4,
                    }
                ],
                [
                    {
                        key: "positive_reviews",
                        label: "Positive",
                        color: '#A0E199',
                        count: 1
                    },
                    {
                        key: "neutral_reviews",
                        label: "Neutral",
                        color: '#FCE494',
                        count: 12
                    },
                    {
                        key: "negative_reviews",
                        label: "Negative",
                        color: '#FE4027',
                        count: 4,
                    }
                ],
                [
                    {
                        key: "positive_reviews",
                        label: "Positive",
                        color: '#A0E199',
                        count: 17
                    },
                    {
                        key: "neutral_reviews",
                        label: "Neutral",
                        color: '#FCE494',
                        count: 43
                    },
                    {
                        key: "negative_reviews",
                        label: "Negative",
                        color: '#FE4027',
                        count: 14,
                    }
                ]
            ],
            tableData: [
                {
                    name: 'Test 1',
                    data: 1234,
                },
                {
                    name: 'Test 2',
                    data: 1234,
                },
                {
                    name: 'Test 4',
                    data: 1234,
                },
            ],
            barChart: [
                {
                    category: "4-5",
                    color: '#A0E199',
                    count: 120
                },
                {
                    category: "3",
                    color: '#FCE494',
                    count: 30
                },
                {
                    category: "1-2",
                    color: '#FE4027',
                    count: 200,
                }
            ],
            barOneChart: [
                {
                    category: "5",
                    count: 120
                },
                {
                    category: "4",
                    count: 120
                },
                {
                    category: "3",
                    count: 30
                },
                {
                    category: "2",
                    count: 200,
                },
                {
                    category: "1",
                    count: 200,
                },
                {
                    category: "0",
                    count: 200,
                }
            ],
            bulletOne: [
                {
                    label: 'Service',
                    count: 50,
                },
                {
                    label: 'Friendly',
                    count: 25,
                },
                {
                    label: 'Options',
                    count: 5,
                },
            ],
            singleLineData: {
                name: 'Single Line Data',
                data: [
                    {
                        x: "2020-02-23",
                        y: 0
                    },
                    {
                        x: "2020-02-24",
                        y: 1
                    },
                    {
                        x: "2020-02-25",
                        y: 2
                    },
                    {
                        x: "2020-02-26",
                        y: 3
                    },
                    {
                        x: "2020-02-27",
                        y: 4
                    },
                ]
            },
            multiLineData: [
                {
                    name: "Positive Reviews",
                    key: "positive_review_data",
                    color: colors.success,
                    data: [
                        {
                            x: "2020-02-23",
                            y: 0
                        },
                        {
                            x: "2020-02-24",
                            y: 1
                        },
                        {
                            x: "2020-02-25",
                            y: 2
                        },
                        {
                            x: "2020-02-26",
                            y: 3
                        },
                        {
                            x: "2020-02-27",
                            y: 4
                        },
                    ]
                },
                {
                    name: "Neutral Reviews",
                    key: "neutral_review_data",
                    color: colors.warning,
                    data: [
                        {
                            x: "2020-02-23",
                            y: 2
                        },
                        {
                            x: "2020-02-24",
                            y: 2
                        },
                        {
                            x: "2020-02-25",
                            y: 3
                        },
                        {
                            x: "2020-02-26",
                            y: 3
                        },
                        {
                            x: "2020-02-27",
                            y: 3
                        },
                    ]
                },
                {
                    name: "Negative Reviews",
                    key: "negative_reviews_data",
                    color: colors.error,
                    data: [
                        {
                            x: "2020-02-23",
                            y: 4
                        },
                        {
                            x: "2020-02-24",
                            y: 3
                        },
                        {
                            x: "2020-02-25",
                            y: 2
                        },
                        {
                            x: "2020-02-26",
                            y: 1
                        },
                        {
                            x: "2020-02-27",
                            y: 0
                        },
                    ]
                },
            ],
        };
    }
};
</script>
<style lang="scss">
    .GraphDemo {
        min-height: 100%;
        margin: 50px;
        padding: 25px;
        display: flex;
        flex-direction: column;
        &__row {
            width: 100%;
            display: flex;
            flex-direction: row;
            margin: 1rem 0;
            &--bar {
                display: flex;
                flex-direction: row;
                margin: 1rem 0;
                height: 25rem;
            }
        }
        &__multi-chart,
        &__table-chart,
        &__single-chart {
            height: 15rem;
            margin: auto 1rem;
        }
        &__table-chart{
            width: 15rem;
        }
        &__bar-chart {
            width: 20rem;
        }
        &__line-chart {
            width: 40rem;
        }
    }
</style>
